const BASE_PATH = "https://iras.skywarn.de/";
const OVERLAY = `${BASE_PATH}radardaten-public/lokal/animation/googlemaps.png`
const OVERLAY_LOOP = `${BASE_PATH}radardaten-public/lokal/animation/googlemaps_animiert.gif`
const BACKGROUND_LOCATION = `${BASE_PATH}radardaten-public/lokal/hintergruende/hintergrund_composit_mercator` //only a prefix
const RADARIMG_PATH = `${BASE_PATH}radardaten-public/lokal/`;


export {
    OVERLAY, OVERLAY_LOOP, BACKGROUND_LOCATION, RADARIMG_PATH
};